<template>
  <div>
    <div class="d-flex justify-space-between">
      <div></div>
      <div class="d-inline-flex">
        <span class="text-h5 font-weight-normal">
          Integração com Sistema iSET
          {{ selectedIsetTable != '' ? `[${selectedIsetTable}]` : `` }}
        </span>
      </div>
      <div class="d-inline-flex">
        <v-btn
          elevation="0"
          color="blue-grey"
          class="white--text text-caption rounded-br-lg rounded-tl-lg rounded-bl-0 rounded-tr-0"
          small
          @click="openSynchronizationLog()"
        >
          <span>Log</span>
          <v-icon right>mdi-format-list-bulleted</v-icon>
        </v-btn>
      </div>
    </div>
    <v-row>
      <v-col xl="6" lg="6" md="6" sm="12">
        <config-api
          :integrationData="integrationData"
          :integrationsList="integrationsList"
          @openIntegrationDataDialog="openIntegrationDataDialog($event)"
          @verifyIntegrationStatus="verifyIntegrationStatus"
          @runIntegration="runIntegration"
          @getIntegrations="getIntegrations(integrationName)"
        />
      </v-col>
      <v-col xl="6" lg="6" md="6" sm="12">
        <div class="d-flex-inline flex-wrap">
          <v-card dark>
            <v-card-title class="d-flex justify-space-between">
              <div>
                <span>Tabelas iSET</span>
              </div>
              <div>
                <v-icon>mdi-table</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex flex-wrap">
                <div v-for="button in isetTablesButtons" :key="button.name">
                  <v-btn
                    v-if="button.released"
                    :color="button.selected ? `green darken-4` : `green`"
                    class="mx-1 my-1"
                    @click="selectIsetTable(button.name)"
                    :disabled="
                      !(integrationData.ATIVO && integrationData.ATIVO == 'S')
                    "
                  >
                    <span class="text-caption">{{ button.name }}</span>
                  </v-btn>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <div class="d-flex flex-wrap" v-if="selectedIsetTable != ''">
                <div
                  v-for="action in selectedIsetTableActions"
                  :key="action.name"
                >
                  <v-btn
                    :color="action.selected ? 'cyan darken-4' : 'cyan darken-1'"
                    v-if="action.released"
                    class="mx-1 my-1"
                    @click="selectIsetTableActions(action.value)"
                  >
                    <span class="text-caption">{{ action.name }}</span>
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-card>
          <v-card class="mt-1" dark v-if="showFieldId">
            <v-card-title class="d-flex justify-space-between">
              <div>
                <span>Informar ID</span>
              </div>
              <div>
                <v-icon>mdi-identifier</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-between">
                <v-text-field
                  dense
                  outlined
                  class="text-caption"
                  label="ID da busca"
                  placeholder="Informe o ID"
                  type="number"
                  value=""
                  v-model="fieldId"
                />
                <v-btn
                  color="info accent-3"
                  @click="searchById(`${selectedAction}`)"
                  class="mx-1"
                >
                  <span class="text-caption">Buscar</span>
                  <v-icon small right>mdi-magnify</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mt-1" dark v-else-if="showInsertButton">
            <v-card-title>
              <div>
                <span>Enviar Produtos</span>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-around">
                <v-btn
                  color="info accent-3"
                  class="mx-1"
                  @click="sendProducts"
                  :disabled="!dataList || (dataList && dataList.length == 0)"
                >
                  <span class="text-caption">Enviar</span>
                  <v-icon small right>mdi-upload</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-card
            class="mt-1"
            dark
            v-else-if="selectedAction == 'categorias.inserir'"
          >
            <v-card-title class="d-flex justify-space-between">
              <div>
                <span>Selecione as Categorias</span>
              </div>
              <div>
                <v-icon>mdi-identifier</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-around">
                <v-btn
                  color="info accent-3"
                  class="mx-1"
                  @click="sendCategories"
                >
                  <span class="text-caption">Enviar</span>
                  <v-icon small right>mdi-upload</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
          <v-card
            class="mt-1"
            dark
            v-else-if="selectedAction == 'fabricantes.inserir'"
          >
            <v-card-title class="d-flex justify-space-between">
              <div>
                <span>Selecione os Fabricantes</span>
              </div>
              <div>
                <v-icon>mdi-identifier</v-icon>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-around">
                <v-btn
                  color="info accent-3"
                  class="mx-1"
                  @click="sendManufacturers"
                >
                  <span class="text-caption">Enviar</span>
                  <v-icon small right>mdi-upload</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="selectedIsetTable != ''">
      <v-col cols="12">
        <iset-filters
          :tableActive="selectedIsetTable"
          @filter="performFilters($event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <!-- Tabela  -->
        <v-data-table dark :items="dataList" :headers="dataHeader">
          <template v-slot:item.categories="{ item }">
            <v-btn
              color="blue accent-4"
              x-small
              @click="showCategories(item.categories)"
              disabled
            >
              <span class="text-caption">ver categorias</span>
            </v-btn>
          </template>
          <template v-slot:item.subCategories="{ item }">
            <v-btn
              color="blue accent-4"
              x-small
              @click="showCategories(item)"
              :disabled="item.subCategories.length == 0"
            >
              <span class="text-caption">ver sub-categorias</span>
            </v-btn>
          </template>
          <template v-slot:item.url="{ item }">
            <v-btn
              v-if="item.url != ''"
              color="green accent-4"
              target="_blank"
              :href="item.url"
              x-small
            >
              <v-icon small>mdi-web</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.images="{ item }">
            <v-btn
              v-if="item.images"
              color="orange darken-1"
              x-small
              @click="showProductImages(item.images)"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
            <v-btn color="info" v-else x-small>
              <v-icon small>mdi-image-off</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.dimensions="{ item }">
            <span
              >{{ item.dimensions.length }}x{{ item.dimensions.height }}x{{
                item.dimensions.width
              }}</span
            >
          </template>
          <template v-slot:item.shipping="{ item }">
            <v-btn
              @click="showOrderData(item.shipping, 'shipping')"
              color="orange darken-1"
              x-small
            >
              <span class="text-caption">envios</span>
              <v-icon small right>mdi-truck</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.nfe="{ item }">
            <v-btn
              @click="showOrderData(item.nfe, 'nfe')"
              color="red darken-1"
              x-small
            >
              <span class="text-caption">nfe</span>
              <v-icon small right>mdi-receipt</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.payment="{ item }">
            <v-btn
              @click="showOrderData(item.payment, 'payment')"
              color="green darken-1"
              x-small
            >
              <span class="text-caption">pagamento</span>
              <v-icon small right>mdi-cash-multiple</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.customer="{ item }">
            <v-btn
              @click="showOrderData(item.customer, 'customer')"
              color="blue darken-1"
              x-small
            >
              <span class="text-caption">cliente</span>
              <v-icon small right>mdi-account</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.detalharPedido="{ item }">
            <v-btn
              @click="showOrderData(item.orderId, 'detalhar')"
              color="purple darken-1"
              x-small
            >
              <span class="text-caption">detalhar</span>
              <v-icon small right>mdi-details</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.editarProdutosIntegracao="{ item }">
            <v-btn
              @click="editIntegrationProducts(item)"
              color="success darken-1"
              x-small
            >
              <span class="text-caption">editar</span>
              <v-icon small right>mdi-pen</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.editarCategoriasIntegracao="{ item }">
            <v-btn
              @click="editIntegrationCategories(item)"
              color="success darken-1"
              x-small
            >
              <span class="text-caption">editar</span>
              <v-icon small right>mdi-pen</v-icon>
            </v-btn>
          </template>
          <template
            v-if="selectedAction == 'produtos.inserir'"
            v-slot:item.CATEGORIES="{ item }"
          >
            <span v-for="category in item.CATEGORIES" :key="category.CODIGO"
              >{{ category.CODIGO }},</span
            >
          </template>
          <template
            v-if="selectedAction == 'produtos.inserir'"
            v-slot:item.FABRICANTE_INTEGRACAO="{ item }"
          >
            <span>
              {{
                `${
                  item.FABRICANTE_INTEGRACAO.CODIGO
                    ? `${item.FABRICANTE_INTEGRACAO.CODIGO} - ${item.FABRICANTE_INTEGRACAO.NOME}`
                    : `${item.FABRICANTE_INTEGRACAO}`
                }`
              }}
            </span>
          </template>
          <template
            v-if="selectedAction == 'categorias.lista'"
            v-slot:item.img="{ item }"
          >
            <v-btn
              v-if="item.img"
              x-small
              color="blue accent-2"
              target="_blank"
              :href="item.img"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
            <v-btn v-else x-small color="red accent-2">
              <v-icon small>mdi-image-off</v-icon>
            </v-btn>
          </template>
          <template
            v-if="selectedAction == 'categorias.lista'"
            v-slot:item.img_h="{ item }"
          >
            <v-btn
              v-if="item.img_h"
              x-small
              color="blue accent-2"
              target="_blank"
              :href="item.img_h"
            >
              <v-icon small>mdi-image</v-icon>
            </v-btn>
            <v-btn v-else x-small color="red accent-2">
              <v-icon small>mdi-image-off</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <category-dialog
      v-if="dialogs.showCategoryDialog"
      :showDialog="dialogs.showCategoryDialog"
      @goBack="dialogs.showCategoryDialog = false"
      :objectData="dialogs.categoryObject"
    />
    <message-dialog
      :showDialog="dialogs.showMessageDialog"
      :message="dialogs.messages"
      @close="dialogs.showMessageDialog = false"
    />
    <select-basic
      v-if="dialogs.showSelectBasic"
      :showDialog="dialogs.showSelectBasic"
      :componentOwner="integrationName"
      @close="dialogs.showSelectBasic = false"
      @addItens="showSelectedProduct($event)"
    />
    <product-dialog
      v-if="dialogs.showProductDialog"
      :showDialog="dialogs.showProductDialog"
      :objectData="dialogs.productObject"
      @goBack="dialogs.showProductDialog = false"
    />
    <base-dialog
      :showDialog="dialogs.showImageDialog"
      v-if="dialogs.showImageDialog"
      width="800"
    >
      <template v-slot:body>
        <v-card elevation="24" class="mx-auto align-content-center">
          <v-card-title>
            <span>Image Dialog</span>
          </v-card-title>
          <v-card-text>
            <v-carousel
              :continuous="false"
              :cycle="false"
              :show-arrows="dialogs.imagesList.length > 1"
              hide-delimiter-background
              delimiter-icon="mdi-circle"
              height="450"
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(image, index) in dialogs.imagesList"
                :key="index"
              >
                <v-sheet height="100%">
                  <v-img
                    class="display-3"
                    max-height="430"
                    :max-width="widthOverlay"
                    :min-width="widthOverlay"
                    min-height="430"
                    contain
                    :src="image"
                  />
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="info"
              small
              dark
              class="ml-1 px-1 py-1"
              @click="dialogs.showImageDialog = false"
            >
              <v-icon small left>mdi-exit-to-app</v-icon>
              <span class="text-overline">{{ $t('labels.voltar') }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-dialog>
    <select-category
      v-if="dialogs.showSelectCategory"
      @goBack="dialogs.showSelectCategory = false"
      :showDialog="dialogs.showSelectCategory"
      @addItens="showSelectedCategories($event)"
    />
    <select-manufacturer
      v-if="dialogs.showSelectManufacturer"
      @goBack="dialogs.showSelectManufacturer = false"
      :showDialog="dialogs.showSelectManufacturer"
      @addItens="showSelectedManufacturers($event)"
    />
    <select-brand
      v-if="dialogs.showSelectBrand"
      @goBack="dialogs.showSelectBrand = false"
      :showDialog="dialogs.showSelectBrand"
      @addItens="showSelectedManufacturers($event)"
    />

    <order-data
      v-if="dialogs.showOrderDataDialog"
      @goBack="dialogs.showOrderDataDialog = false"
      :showDialog="dialogs.showOrderDataDialog"
      :orderData="dialogs.orderData"
    />

    <integration-item
      v-if="dialogs.showIntegrationItemDialog"
      @goBack="dialogs.showIntegrationItemDialog = false"
      @submitForm="editIntegrationProducts($event)"
      :showDialog="dialogs.showIntegrationItemDialog"
      :objectData="dialogs.objectItem"
    />

    <integration-category
      v-if="dialogs.showIntegrationCategoryDialog"
      @goBack="dialogs.showIntegrationCategoryDialog = false"
      @submitForm="editIntegrationCategories($event)"
      :showDialog="dialogs.showIntegrationCategoryDialog"
      :objectData="dialogs.objectCategory"
    />

    <!-- <iset-table-options 
      :showDialog="true"
    /> -->

    <integration-data-dialog
      v-if="dialogs.showIntegrationDataDialog"
      :showDialog="dialogs.showIntegrationDataDialog"
      :objectData="dialogs.objectIntegration"
      @goBack="closeIntegrationDataDialog('goBack')"
      @submitForm="closeIntegrationDataDialog('submitForm')"
    />

    <synchronization-log
      v-if="dialogs.showSynchronizationLogDialog"
      :showDialog="dialogs.showSynchronizationLogDialog"
      @goBack="dialogs.showSynchronizationLogDialog = false"
      :synchronizationLog="synchronizationLog"
      :getLogs="getLogs"
      :setEmptyLog="setEmptyLog"
    />
  </div>
</template>

<script>
import service from '@/services/integration/IntegrationService'
import isetService from '@/services/integration/iset/IsetService'
import { mapActions, mapGetters } from 'vuex'
import { integrationMixin } from '@/mixins/object/integration/IntegrationMixin'

export default {
  mixins: [integrationMixin],
  components: {
    CategoryDialog: () =>
      import('@/components/unique/integration/iset/CategoryDialog'),
    MessageDialog: () =>
      import('@/components/shared/base-dialog/MessageDialog'),
    SelectBasic: () => import('@/components/object/item/SelectBasic'),
    ProductDialog: () =>
      import('@/components/unique/integration/iset/ProductDialog'),
    BaseDialog: () => import('@/components/shared/base-dialog/BaseDialog'),
    SelectCategory: () => import('@/components/object/category/Select'),
    SelectManufacturer: () => import('@/components/object/manufacturer/Select'),
    OrderData: () => import('@/components/unique/integration/iset/OrderData'),
    IntegrationItem: () =>
      import('@/components/unique/integration/iset/IntegrationItem'),
    IntegrationCategory: () =>
      import('@/components/unique/integration/iset/IntegrationCategory.vue'),
    ConfigApi: () => import('@/components/unique/integration/ConfigApi.vue'),
    IntegrationDataDialog: () =>
      import('@/components/unique/integration/IntegrationData'),
    SelectBrand: () => import('@/components/object/brand/Select'),
    IsetFilters: () => import('@/components/unique/integration/iset/Filters'),
    SynchronizationLog: () =>
      import('@/components/unique/integration/SynchronizationLog'),
    // IsetTableOptions: () => import('@/components/unique/integration/iset/IsetTableOptions')
  },
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
      manufacturerList: 'isetModule/getManufacturerList',
      system: 'systemModule/getCurrentSystem',
      categoriesIset: 'isetModule/getCategoriesIset',
      synchronizationLog: 'isetModule/getSynchronizationLog',
    }),

    isAdmin() {
      return this.authUser.NOME === 'SYSDBA'
    },
    excludedHeaders() {
      return ['image_default', 'categories_path']
    },
    widthOverlay() {
      const size = {
        default: {
          xs: '600',
          sm: '600',
          md: '900',
          lg: '900',
          xl: '1200',
        },
      }
      let breakpointName = this.$vuetify.breakpoint.name
      return size.default[breakpointName] ?? 600
    },
  },
  data: () => {
    return {
      categoriasDiffGestao: 0,
      dialogs: {
        showCategoryDialog: false,
        categoryObject: {},
        showMessageDialog: false,
        messages: [],
        showSelectBasic: false,
        showProductDialog: false,
        productObject: {},
        showImageDialog: false,
        hasImages: false,
        imagesList: [],
        showSelectCategory: false,
        showSelectManufacturer: false,
        showOrderDataDialog: false,
        orderData: {},
        showIntegrationItemDialog: false,
        objectItem: {},
        showIntegrationCategoryDialog: false,
        objectCategory: {},
        showIntegrationDataDialog: false,
        objectIntegration: {},
        showSelectBrand: false,
        showSynchronizationLogDialog: false,
      },
      showFieldId: false,
      showInsertButton: false,
      fieldId: 0,
      isetTablesButtons: [
        //Botao Categorias
        {
          selected: false,
          name: 'Categorias',
          released: true,
          actions: [
            {
              name: 'Lista',
              value: 'categorias.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Lista [ID]',
              value: 'categorias.lista.id',
              released: true,
              selected: false,
            },
            {
              name: 'Detalhes [ID]',
              value: 'categorias.detalhes.id',
              released: true,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'categorias.inserir',
              released: true,
              selected: false,
            },
            {
              name: 'Forçar Sincronismo',
              value: 'categorias.forcar.sincronismo',
              released: false,
              selected: false,
            },
            {
              name: 'Categorias Inválidas',
              value: 'categorias.forcar.delete',
              released: false, // liberar somente para testes "categoriasDiffGestao"
              selected: false,
            },
          ],
        },
        //Botao Produtos
        {
          selected: false,
          name: 'Produtos',
          released: true,
          actions: [
            {
              name: 'Lista Iset',
              value: 'produtos.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Lista Local',
              value: 'produtos.lista.local',
              released: false,
              selected: false,
            },
            {
              name: 'Detalhes [ID]',
              value: 'produtos.detalhes.id',
              released: true,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'produtos.inserir',
              released: true,
              selected: false,
            },
            {
              name: 'Verificar Estoque',
              value: 'produtos.verify',
              released: false,
              selected: false,
            },
            {
              name: 'Limpar Estoque',
              value: 'produtos.clearStock',
              released: false,
              select: false,
            },
          ],
        },
        //Botao Clientes
        {
          selected: false,
          name: 'Clientes',
          released: true,
          actions: [
            {
              name: 'Endereços [ID]',
              value: 'clientes.enderecos',
              released: true,
              selected: false,
            },
          ],
        },
        //Botao Fabricantes
        {
          selected: false,
          name: 'Fabricantes',
          released: true,
          actions: [
            {
              name: 'Lista',
              value: 'fabricantes.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Inserir',
              value: 'fabricantes.inserir',
              released: true,
              selected: false,
            },
          ],
        },
        //Botao Pedidos
        {
          selected: false,
          name: 'Pedidos',
          released: true,
          actions: [
            {
              name: 'Lista',
              value: 'pedidos.lista',
              released: true,
              selected: false,
            },
            {
              name: 'Lista [ID]',
              value: 'pedidos.lista.id',
              released: true,
              selected: false,
            },
          ],
        },
      ],
      integrationName: 'ISET',
      integrationData: {
        BASE_URL: '',
        PASSWORD: '',
        USERNAME: '',
        NOME_EMPRESA: '',
        DE_PARA: '',
        ITEM_TAXAENTREGA: null,
        ITEM_GENERICO: null,
        FILIAL: null,
        COLUNAS_EXPORTACAO: null,
      },
      selectedIsetTable: '',
      selectedIsetTableActions: [],
      selectedAction: '',
      disableForm: false,
      dataList: [],
      dataHeader: [],
    }
  },
  methods: {
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
      getManufacturers: 'isetModule/getManufacturers',
      getCategoriesIset: 'isetModule/getCategoriesIset',
      deleteCategoriesGestao: 'isetModule/deleteCategoriesGestao',
      getLogs: 'isetModule/getSynchronizationLog',
      setEmptyLog: 'isetModule/setEmptySynchronizationLog',
    }),
    async verifyIntegrationStatus(item = null) {
      if (this.integrationData.USERNAME) {
        this.disableForm = true
        this.showFieldId = false
        this.showInsertButton = false
        this.integrationData = {}
        this.dataHeader = []
        this.dataList = []
        this.selectedIsetTable = ''
        this.selectedIsetTableActions = []
        this.selectedAction = ''
      } else
        try {
          if (item != null) {
            this.setLoadingDialogMessage('Carregando Dados da Integração')
            this.showLoadingDialog(true)
            let response = await service.getIntegration({
              name: item.NOME_EMPRESA,
            })
            if (response.data.length > 0) {
              let integrationData = response.data[0]
              this.integrationData = integrationData
              this.disableForm = true
            } else {
              this.$toasted.info('Não foram encontrados dados')
              this.disableForm = false
            }
          } else {
            throw `Nenhuma integração selecionada.`
          }
        } catch (error) {
          this.$toasted.error(error)
        } finally {
          this.showLoadingDialog(false)
        }
    },
    async runIntegration() {
      try {
        if (this.integrationData && this.integrationData.ATIVO == 'S')
          this.setLoadingDialogMessage('Parando serviço')
        else if (this.integrationData && this.integrationData.ATIVO == 'N')
          this.setLoadingDialogMessage('Iniciando Serviço')

        this.showLoadingDialog(true)

        let response = ''

        let integrationData = { ...this.integrationData }

        if (this.integrationData && this.integrationData.ATIVO == 'S') {
          integrationData.ATIVO = 'N'
          this.disableForm = false
        } else if (this.integrationData && this.integrationData.ATIVO == 'N') {
          integrationData.ATIVO = 'S'
        }

        response = await service.updateIntegration(integrationData)
        this.integrationData.ATIVO = integrationData.ATIVO

        if (this.integrationData.ATIVO == 'N') this.clearSelectionsAndLists()

        this.$toasted.success(response.status)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    clearSelectionsAndLists() {
      this.isetTablesButtons.forEach((button) => {
        this.unselectButton(button)
      })
      this.selectedIsetTable = ''
    },
    unselectButton(buttonReference) {
      buttonReference.selected = false
    },
    selectIsetTable(tableName) {
      if (tableName != this.selectedIsetTable) {
        let selectedButton = this.isetTablesButtons.find(
          (button) => button.name == tableName
        )
        this.dataList = []
        this.dataHeader = []
        this.isetTablesButtons.forEach((button) => {
          if (button.name != tableName) this.unselectButton(button)
        })
        this.selectedIsetTableActions.forEach((action) => {
          this.unselectButton(action)
        })

        selectedButton.selected = true
        this.selectedIsetTable = selectedButton.name
        this.selectedIsetTableActions = selectedButton.actions
        if (this.showFieldId) this.showFieldId = false
        this.selectIsetTableActions(`${tableName.toLowerCase()}.lista`)
      } else {
        this.selectedIsetTableActions.forEach((action) => {
          this.unselectButton(action)
        })
        this.selectedIsetTableActions = []
        this.dataList = []
        this.dataHeader = []
        this.selectedAction = ''
        if (this.showFieldId) this.showFieldId = false

        this.isetTablesButtons.forEach((button) => {
          this.unselectButton(button)
        })
        this.selectedIsetTable = ''
      }
    },
    extractData(dataList) {
      if (Array.isArray(dataList)) {
        if (dataList.length > 0) {
          Object.keys(dataList[0]).forEach((dataHeader) => {
            if (!this.excludedHeaders.find((header) => header == dataHeader))
              this.dataHeader.push({ text: dataHeader, value: dataHeader })
          })
          this.dataList = dataList
        } else throw `Não foram encontrados dados [${this.selectedIsetTable}]`
      } else {
        let dataArray = Object.keys(dataList)
        Object.keys(dataList[dataArray[0]]).forEach((dataHeader) => {
          this.dataHeader.push({ text: dataHeader, value: dataHeader })
        })
        Object.keys(dataList).forEach((data) => {
          this.dataList.push({
            ...dataList[data],
          })
        })
      }
    },

    async verifyCategoriesISETxGestao(isetCategories) {
      let categ = []
      Object.keys(isetCategories).forEach((element) => {
        categ.push(isetCategories[element].id)
        const subCategories = isetCategories[element]?.subCategories
        if (subCategories)
          Object.keys(subCategories).forEach((sub) => {
            console.log(sub, subCategories[sub].id)
            categ.push(subCategories[sub].id)
          })
      })

      if (categ.length > 0) {
        const payload = {
          action: 'search',
          categories: categ,
        }
        const { status } = await this.deleteCategoriesGestao(payload)

        this.categoriasDiffGestao = parseInt(status)
      }

      return categ
    },

    async selectIsetTableActions(actionName, filters = {}) {
      try {
        this.showInsertButton = false
        this.showFieldId = false

        let selectedAction = this.selectedIsetTableActions.find(
          (action) => action.value == actionName
        )
        selectedAction.selected = true
        this.selectedAction = selectedAction.value
        this.selectedIsetTableActions.forEach((action) => {
          if (action.value != selectedAction.value) this.unselectButton(action)
        })

        if (this.selectedIsetTable == 'Categorias') {
          if (selectedAction.value == 'categorias.lista') {
            if (this.showFieldId) this.showFieldId = false
            try {
              this.setLoadingDialogMessage('Carregando Categorias')
              this.showLoadingDialog(true)
              await this.getCategoriesIset({})
              this.verifyCategoriesISETxGestao(
                this.categoriesIset.data.response
              )
              this.dataList = []
              this.dataHeader = []
              if (!this.verificaErroChave(this.categoriesIset.data))
                this.extractData(this.categoriesIset.data.response)
              else throw this.categoriesIset.data.message
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (
            selectedAction.value == 'categorias.lista.id' ||
            selectedAction.value == 'categorias.detalhes.id'
          ) {
            this.showFieldId = true
          } else if (selectedAction.value == 'categorias.inserir') {
            this.dialogs.showSelectCategory = true
          } else if (selectedAction.value == 'categorias.forcar.sincronismo') {
            try {
              this.setLoadingDialogMessage('Forçando Sincronismo')
              this.showLoadingDialog(true)
              let response = await isetService.forceSinchronization()
              if (!this.verificaErroChave(response.data))
                this.$toasted.success(response.data.OK ?? response)
              else throw response.data.message
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (selectedAction.value == 'categorias.forcar.delete') {
            let message = this.$i18n.t('dialogs.actions', {
              action: 'eliminar',
              nome: 'Categorias',
              codigo: this.categoriasDiffGestao,
            })

            message += '. Não será possível reverter este processo!!'

            const categ = this.verifyCategoriesISETxGestao(
              this.categoriesIset.data.response
            )

            if (
              await this.$root.$confirm('Confirmação', message, {
                color: 'warning',
              })
            ) {
              try {
                this.setLoadingDialogMessage('Enviando requisição...')
                this.showLoadingDialog(true)
                const payload = {
                  categories: categ,
                }
                const { status } = await this.deleteCategoriesGestao(payload)

                this.$toasted.success(status, { duration: 5000 })
              } catch (error) {
                this.$toasted.error(error, { duration: null })
              } finally {
                this.showLoadingDialog(false)
              }
            } else {
              return
            }
          }
        } else if (this.selectedIsetTable == 'Clientes') {
          if (selectedAction.value == 'clientes.enderecos') {
            this.showFieldId = true
          }
        } else if (this.selectedIsetTable == 'Produtos') {
          if (selectedAction.value == 'produtos.lista') {
            try {
              this.setLoadingDialogMessage('Carregando Produtos')
              this.showLoadingDialog(true)
              let response = await isetService.getProducts(filters)
              this.dataList = []
              this.dataHeader = []

              if (!this.verificaErroChave(response.data))
                this.extractData(response.data.result)
              else throw response.data.message
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (selectedAction.value == 'produtos.detalhes.id') {
            this.showFieldId = true
          } else if (selectedAction.value == 'produtos.inserir') {
            this.dialogs.showSelectBasic = true
          } else if (selectedAction.value == 'produtos.verify') {
            try {
              this.setLoadingDialogMessage('Verificando Estoque')
              this.showLoadingDialog(true)
              let response = await isetService.verifyStock()
              this.$toasted.success(response.data.status.OK[0])
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (selectedAction.value == 'produtos.clearStock') {
            try {
              this.setLoadingDialogMessage('Limpando Estoque')
              this.showLoadingDialog(true)
              await isetService.clearStock()
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else {
            this.$toasted.info('Esta ação está sendo implementada')
          }
        } else if (this.selectedIsetTable == 'Fabricantes') {
          if (selectedAction.value == 'fabricantes.lista') {
            try {
              this.setLoadingDialogMessage('Carregando Fabricantes')
              this.showLoadingDialog(true)
              await this.getManufacturers()
              this.dataList = []
              this.dataHeader = []

              if (this.manufacturerList.length > 0)
                this.extractData(this.manufacturerList)
            } catch (error) {
              this.$toasted.error(error)
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (selectedAction.value == 'fabricantes.inserir') {
            if (this.integrationData.DE_PARA.includes('FABRICANTES|MARCAS'))
              this.dialogs.showSelectBrand = true
            else this.dialogs.showSelectManufacturer = true
          } else {
            this.$toasted.info('Esta ação está sendo implementada')
          }
        } else if (this.selectedIsetTable == 'Pedidos') {
          if (selectedAction.value == 'pedidos.lista') {
            try {
              this.setLoadingDialogMessage('Carregando Pedidos')
              this.showLoadingDialog(true)
              let response = await isetService.getPedidos()
              this.dataList = []
              this.dataHeader = []
              if (response.data.orders) this.extractData(response.data.orders)
              else throw response.data
              this.dataHeader.push({
                name: 'Detalhar',
                value: 'detalharPedido',
              })
            } catch (error) {
              this.$toasted.error(error, { duration: null })
            } finally {
              this.showLoadingDialog(false)
            }
          } else if (selectedAction.value == 'pedidos.lista.id') {
            this.showFieldId = true
          }
        }
      } catch (error) {
        this.$toasted.error(`Ocorreu um erro ao consultar [${actionName}]`)
      }
    },
    async searchById(type) {
      try {
        this.showLoadingDialog(true)
        let id = this.fieldId
        if (type == 'categorias.lista.id') {
          this.setLoadingDialogMessage('Carregando Categorias')
          let response = await isetService.getCategories({ categoriaPai: id })
          if (response.data && response.data.status == 200) {
            this.dataList = []
            this.dataHeader = []
            this.extractData(response.data.response ?? response.data)
          } else if (response.data && response.data.status == 400)
            throw response.data.message
        } else if (type == 'categorias.detalhes.id') {
          this.setLoadingDialogMessage('Carregando Categorias')
          let response = await isetService.getCategory(id)
          if (response.data.status == 400) throw response.data.message
          else {
            this.dialogs.categoryObject =
              response.data.response ?? response.data
            this.dialogs.showCategoryDialog = true
          }
        } else if (type == 'clientes.enderecos') {
          this.setLoadingDialogMessage('Carregando Endereços')
          let response = await isetService.getAddresses({ id: id })
          if (response.data.length > 0) {
            this.dataList = []
            this.dataHeader = []
            this.extractData(response.data)
          } else {
            throw `Não foi encontrado endereço com o id [${this.fieldId}]`
          }
        } else if (type == 'produtos.detalhes.id') {
          this.setLoadingDialogMessage('Carregando Produto')
          let response = await isetService.getProduct(id)
          if (response.data && response.data.result.length > 0) {
            this.dialogs.showProductDialog = true
            this.dialogs.productObject = response.data.result[0]
          } else {
            throw `Não foi encontrado produto com o id [${this.fieldId}]`
          }
        } else if (type == 'pedidos.lista.id') {
          this.setLoadingDialogMessage(`Carregando Pedido [${id}]`)
          let response = await isetService.getPedido(id)
          if (response.data && response.data.status == 200) {
            this.dialogs.showOrderDataDialog = true
            this.dialogs.orderData = response.data
          } else if (response.data && response.data.status == 400)
            throw response.data.message
        } else {
          throw `Malformed function searchByID(type) expected STRING received ${type}`
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },

    showCategories(data) {
      this.dataList = []
      this.dataHeader = []
      this.extractData(data.subCategories)
    },
    showSelectedCategories(e) {
      if (e.length > 0) {
        this.dialogs.showSelectCategory = false
        this.dataList = []
        this.dataHeader = []
        this.dataHeader.push({
          text: 'Ações',
          value: 'editarCategoriasIntegracao',
        })
        this.dataHeader.push({ text: 'Subtítulo', value: 'SUBTITULO' })
        this.dataHeader.push({ text: 'Cat. Pai', value: 'PARENT_ID' })
        this.extractData(e)
      }
    },
    showSelectedManufacturers(e) {
      if (e.length > 0) {
        if (this.integrationData.DE_PARA.includes('FABRICANTES|MARCAS'))
          this.dialogs.showSelectBrand = false
        else this.dialogs.showSelectManufacturer = false

        this.dataList = []
        this.dataHeader = []
        this.extractData(this.convertManufacturersToIset(e))
      }
    },
    convertManufacturersToIset(e) {
      let newList = []
      e.forEach((manufacturer) => {
        newList.push({
          NOME: manufacturer.NOME,
        })
      })
      return newList
    },
    convertCategoriesToIset(e) {
      let newList = []

      e.forEach((category) => {
        newList.push({
          ID: category.ID,
          NOME: category.NOME,
          PARENT_ID: category.PARENT_ID ?? null,
          SUBTITULO: category.SUBTITULO,
        })
      })
      return newList
    },
    showSelectedProduct(e) {
      if (e.length > 0) {
        let selectedProductList = []

        e.forEach((product) => {
          console.log('sel', product)
          selectedProductList.push({
            CODIGO: product.CODIGO,
            DESCRICAO: product.DESCRICAO,
            // PRECO: product.PRECOVAREJO[this.system[`CIFRAO${this.system.MOEDAPRINCIPAL}`]],
            PRECO:
              product.item_integracao && product.item_integracao.PRECO > 0
                ? product.item_integracao.PRECO
                : product.PRECOITEM[
                    this.system[`CIFRAO${this.system.MOEDAPRINCIPAL}`]
                  ],
            PRECOINTEGRACAO:
              product.item_integracao && product.item_integracao.PRECO
                ? product.item_integracao.PRECO
                : 0,
            PRECOCADASTRO:
              product.PRECOITEM[
                this.system[`CIFRAO${this.system.MOEDAPRINCIPAL}`]
              ],
            IDINTEGRACAO: product.item_integracao
              ? product.item_integracao.IDITEMINTEGRACAO
              : null,
            QUANTIDADEMAXCOMPRA: product.item_integracao
              ? product.item_integracao.QUANTIDADEMAXCOMPRA
              : 0,
            QUANTIDADEMINCOMPRA: product.item_integracao
              ? product.item_integracao.QUANTIDADEMINCOMPRA
              : 0,
            QUANTIDADECRITICA: product.item_integracao
              ? product.item_integracao.QUANTIDADECRITICA
              : 0,
            DIASPARAMANIPULACAO: product.item_integracao
              ? product.item_integracao.DIASPARAMANIPULACAO
              : 0,
            ISFRETEGRATIS:
              product.item_integracao &&
              product.item_integracao.ISFRETEGRATIS === 'S'
                ? true
                : false,
            ISPRODUTOSUPEROFERTA:
              product.item_integracao &&
              product.item_integracao.ISPRODUTOSUPEROFERTA === 'S'
                ? true
                : false,
            ISPRODUTOLANCAMENTO:
              product.item_integracao &&
              product.item_integracao.ISPRODUTOLANCAMENTO === 'S'
                ? true
                : false,
            ISPRODUTODESTAQUE:
              product.item_integracao &&
              product.item_integracao.ISPRODUTODESTAQUE === 'S'
                ? true
                : false,
            ISPRODUTOEXCLUSIVO:
              product.item_integracao &&
              product.item_integracao.ISPRODUTOEXCLUSIVO === 'S'
                ? true
                : false,
            ISEMBALARPRESENTE:
              product.item_integracao &&
              product.item_integracao.ISEMBALARPRESENTE === 'S'
                ? true
                : false,
            ISPERMITIRCOMPRA:
              product.item_integracao &&
              product.item_integracao.ISPERMITIRCOMPRA === 'N'
                ? false
                : true,
            FABRICANTE_INTEGRACAO:
              product.item_integracao &&
              product.item_integracao.FABRICANTE_INTEGRACAO
                ? product.item_integracao.FABRICANTE_INTEGRACAO
                : '',
            CATEGORIES: product.item_integracao?.categorias
              ? this.formatToTreeView(product.item_integracao.categorias)
              : [],
            VENDAINTERNET: product.item_integracao
              ? product.item_integracao.VENDAINTERNET
              : 'N',
          })
        })
        this.showInsertButton = true
        this.dialogs.showSelectBasic = false
        this.dataList = []
        this.dataHeader = []
        this.dataHeader.push({
          text: 'Ações',
          value: 'editarProdutosIntegracao',
        })
        this.extractData(selectedProductList)
        this.dialogs.messages = []
        this.dialogs.messages.push(
          'Confira na tabela os itens selecionados',
          "Se estiverem corretos clique em 'Enviar' "
        )
        this.dialogs.showMessageDialog = true
      } else {
        this.$toasted.success('Nenhum item foi selecionado.')
      }
    },

    formatToTreeView(categories) {
      return categories.map((cat) => ({
        id: cat.ID,
        name: cat.NOME,
        ...cat,
      }))
    },

    async sendProducts() {
      try {
        1
        this.showLoadingDialog(true)
        this.setLoadingDialogMessage(
          'Enviando os Itens para a Tabela de Sincronização'
        )
        let response = await isetService.integrateProducts(
          this.convertProductToIset(this.dataList)
        )
        if (response.data.status == 200)
          this.$toasted.success(
            `Item inserido com ID ${response.data.productId} no sistema ISET`
          )
        else if (response.status == 200 && response.data)
          this.$toasted.success(response.data.OK[0])
        this.dataList = []
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    convertProductToIset(dataList) {
      let newDataList = []

      dataList.forEach((product) => {
        if (
          ((!product.PRECOINTEGRACAO || product.PRECOINTEGRACAO === 0) &&
            product.PRECO == product.PRECOCADASTRO) ||
          (product.PRECOINTEGRACAO > 0 && product.PRECO == 0)
        )
          product.PRECO = null
        newDataList.push({
          ...product,
          VENDAINTERNET: 'S',
          categories:
            product.CATEGORIES.length > 0
              ? product.CATEGORIES.map((category) => {
                  return category.CODIGO
                })
              : null,
          ISFRETEGRATIS: product.ISFRETEGRATIS ? 'S' : 'N',
          ISPRODUTOSUPEROFERTA: product.ISPRODUTOSUPEROFERTA ? 'S' : 'N',
          ISPRODUTOLANCAMENTO: product.ISPRODUTOLANCAMENTO ? 'S' : 'N',
          ISPRODUTODESTAQUE: product.ISPRODUTODESTAQUE ? 'S' : 'N',
          ISPRODUTOEXCLUSIVO: product.ISPRODUTOEXCLUSIVO ? 'S' : 'N',
          ISEMBALARPRESENTE: product.ISEMBALARPRESENTE ? 'S' : 'N',
          ISPERMITIRCOMPRA: product.ISPERMITIRCOMPRA ? 'S' : 'N',
        })
      })

      return { items: newDataList }
    },
    showProductImages(imagesList) {
      if (imagesList.length > 0) {
        this.dialogs.imagesList = imagesList
        this.dialogs.showImageDialog = true
      }
    },
    async sendCategories() {
      try {
        if (this.dataList.length > 0) {
          this.$toasted.success(`Inserindo ${this.selectedIsetTable}`)
          let categoriesObject = {
            categories: this.convertCategoriesToIset(this.dataList),
          }
          let response = await isetService.integrateCategories(categoriesObject)
          if (response && response.data) {
            response.data.OK.forEach((message) => {
              this.$toasted.success(message)
            })
            this.dataList = []
          }
        } else {
          throw `Não foi selecionado ${this.selectedIsetTable}`
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    async sendManufacturers() {
      try {
        if (this.dataList.length > 0) {
          this.setLoadingDialogMessage(
            `Inserindo Registros [${this.selectedIsetTable}]`
          )
          this.showLoadingDialog(true)
          let manufacturersObject = {
            manufacturers: this.dataList,
          }
          let response = await isetService.integrateManufacturers(
            manufacturersObject
          )
          if (response && response.data) {
            response.data.OK.forEach((message) => {
              this.$toasted.success(message)
            })
            this.dataList = []
          }
        } else {
          throw `Nenhum fabricante selecionado`
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async showOrderData(data, type) {
      if (type == 'shipping') {
        this.dialogs.orderData = { order: { shipping: { ...data } } }
        this.dialogs.showOrderDataDialog = true
      } else if (type == 'nfe') {
        this.dialogs.orderData = { order: { nfe: { ...data } } }
        this.dialogs.showOrderDataDialog = true
      } else if (type == 'payment') {
        this.dialogs.orderData = { order: { payment: { ...data } } }
        this.dialogs.showOrderDataDialog = true
      } else if (type == 'customer') {
        this.dialogs.orderData = { order: { customer: { ...data } } }
        this.dialogs.showOrderDataDialog = true
      } else if (type == 'detalhar') {
        try {
          this.setLoadingDialogMessage(`Carregando Pedido [${data}]`)
          this.showLoadingDialog(true)
          let response = await isetService.getPedido(data)
          this.dialogs.showOrderDataDialog = true
          this.dialogs.orderData = response.data
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.showLoadingDialog(false)
        }
      } else {
        this.$toasted.error('Ação inválida.')
      }
    },
    editIntegrationProducts(item) {
      if (this.dialogs.showIntegrationItemDialog) {
        let itemIndex = this.dataList.findIndex(
          (product) => product.CODIGO === item.CODIGO
        )
        this.dataList[itemIndex] = item
        let newDataList = []
        this.dataList.forEach((product) => {
          newDataList.push(product)
        })
        this.dataList = newDataList
      }
      this.dialogs.objectItem = item
      this.dialogs.showIntegrationItemDialog =
        !this.dialogs.showIntegrationItemDialog
    },
    editIntegrationCategories(item) {
      if (this.dialogs.showIntegrationCategoryDialog) {
        let categoryIndex = this.dataList.findIndex(
          (category) => category.ID === item.ID
        )
        this.dataList[categoryIndex] = item
        let newDataList = []
        this.dataList.forEach((category) => {
          newDataList.push(category)
        })
        this.dataList = newDataList
      }
      this.dialogs.objectCategory = item
      this.dialogs.showIntegrationCategoryDialog =
        !this.dialogs.showIntegrationCategoryDialog
    },
    openIntegrationDataDialog(integrationData = null) {
      if (integrationData && integrationData.NOME_EMPRESA) {
        this.dialogs.objectIntegration = integrationData
        this.dialogs.showIntegrationDataDialog = true
      } else {
        this.dialogs.objectIntegration = {
          ...this.integrationData,
          NOME_EMPRESA: this.integrationName,
        }
        this.dialogs.showIntegrationDataDialog = true
      }
    },

    closeIntegrationDataDialog() {
      this.dialogs.showIntegrationDataDialog = false
      this.getIntegrations(this.integrationName)
    },
    verificaErroChave(data) {
      if (data.status != 200) return true
      else return false
    },
    performFilters(event) {
      this.selectIsetTableActions(event.action, event.filters)
    },
    openSynchronizationLog() {
      this.dialogs.showSynchronizationLogDialog = true
    },
    async fetch() {
      try {
        await this.getIntegrations(this.integrationName)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>
